import React, { useState, useEffect } from 'react'
import { RadioGroup } from '../../../ui'
import { useStore } from '../../../StateProvider'
import { map, isNil } from 'ramda'
import { getUserValue, radioValueConverter } from '../utils'

/**
 * @param {OptionProps} list
 * @param {?string} validValue
 * @param {?boolean} isVertical
 * @param {string} label
 * @param {string} name
 * @param {?string} defaultValue
 */
const ExternalRadioGroup = ({ list, validValue, isVertical, label, name, defaultValue }) => {
  const [value, setValue] = useState('')
  const [isValid, setIsValid] = useState(false)
  const [{ user, form: { accId } }, dispatch] = useStore()
  const userValue = getUserValue(accId, user, name)
  const swiftValue = getUserValue(accId, user, 'swiftCode')
  const ibanValue = getUserValue(accId, user, 'iban')

  useEffect(() => {
    if (name === 'isSwiftOrIban') return
    const newValue = !isNil(userValue) ? radioValueConverter(userValue) : defaultValue
    if (newValue) {
      presetValue(newValue)
    }
  }, [defaultValue, name, userValue])

  /**
   * preset value for radio group with 'iban' & 'swift' options named 'isSwiftOrIban'.
   * If text field 'iban' or 'swift' has value then set value of radio group
   */
  useEffect(() => {
    if (name !== 'isSwiftOrIban') return
    if (swiftValue?.length > 0) {
      presetValue('swiftCode')
      return
    }
    if (ibanValue?.length > 0) {
      presetValue('iban')
      return
    }
    if (defaultValue) {
      presetValue(defaultValue)
    }
  }, [defaultValue, name, swiftValue, ibanValue])

  const presetValue = (value) => {
    const isValid = validValue ? value === validValue : true
    setValue(value)
    setIsValid(isValid)
    dispatch({ type: 'setExtFieldValue', name, value })
    dispatch({ type: 'setValidationFld', name, value: isValid })
    if (name === 'transactionsSignificantSize') {
      dispatch({ type: 'setExtFieldValue', name: 'isTransactionsSizeFieldsShown', value: isValid })
    }
  }

  const onChange = ({ currentTarget: { value } }) => {
    presetValue(value)
  }

  return (
    <RadioGroup
      name={name}
      onChange={onChange}
      value={value}
      list={list}
      label={label}
      isValid={isValid}
    />
  )
}

const getExternalRadioGroupFields = map(radioButtonField => {
  const {
    list,
    i18n,
    name,
    isVertical,
    validValue,
    defaultValue,
    order
  } = radioButtonField

  return (
    <ExternalRadioGroup
      key={name}
      list={list}
      label={`generatedField.${i18n}`}
      isVertical={isVertical}
      validValue={validValue}
      defaultValue={defaultValue}
      name={name}
      order={order}
    />
  )
})

export { ExternalRadioGroup, getExternalRadioGroupFields }
